import { Col, Row, Form } from "@themesberg/react-bootstrap";
import ReactQuill from 'react-quill';
import DOMPurify from "dompurify";
import 'react-quill/dist/quill.snow.css';

const customStylesForCategorySelect = {
	control: (provided) => ({
		...provided,
		borderRadius: ".5rem",
	}),

	multiValue: (provided) => ({
		...provided,
		borderRadius: ".5rem",
	}),

	multiValueRemove: (provided) => ({
		...provided,
		borderRadius: ".5rem",
	}),

	placeholder: (provided) => ({
		...provided,
		borderRadius: ".5rem",
	}),

	singleValue: (provided, state) => {
		const opacity = state.isDisabled ? 0.5 : 1;
		const transition = "opacity 300ms";

		return {
			...provided,
			opacity,
			transition,
		};
	},
};

const BasicDataInput = ({
	propertyTypeData,
	districtsData,
	localPropertyData,
	setlocalPropertyData,
}) => {
	const handleLowPrice = (e) => {
		setlocalPropertyData({
			...localPropertyData,
			price_low: +e.target.value,
		});
	};

	const handleHighPrice = (e) => {
		setlocalPropertyData({
			...localPropertyData,
			price_high: +e.target.value,
		});
	};

	const handleInputChange = (e) => {
		if (!e?.target?.name) return;

		//console.log(e);
		//console.log(e.target);
		//console.log(e.target.value);

		if (["property_type", "district"].includes(e.target.name)) {
			setlocalPropertyData({
				...localPropertyData,
				[e.target.dataset.key]: +e.target.value,
			});
		} else {
			setlocalPropertyData({ ...localPropertyData, [e.target.name]: e.target.value });
		}
	};

	const handleDescriptionChange = (value, delta, source) => {
		if (source === 'user') {
			value = DOMPurify.sanitize(value);
			setlocalPropertyData({ ...localPropertyData, description: value });	
		}
	}

	console.log(localPropertyData);

	return (
		<div className="px-5">
			<center>
				<h5 className="mb-4">General information</h5>
			</center>
			<Row>
				<Col md={8} className="mb-3">
					<Form.Group id="propertyName">
						<Form.Label>Property Name</Form.Label>
						<Form.Control
							required
							type="text"
							name="name"
							value={localPropertyData?.["name"] ?? ""}
							onChange={(e) => handleInputChange(e)}
							placeholder="Property name"
						/>
					</Form.Group>
				</Col>
				<Col sm={4} className="mb-3">
					<Form.Group id="propertyType">
						<Form.Label>Property Type</Form.Label>
						<Form.Select
							required
							id="state"
							name="property_type"
							defaultValue="0"
							data-key="property_type_id"
							value={localPropertyData?.["property_type_id"] ?? 0}
							onChange={(e) => handleInputChange(e)}
						>
							<option value="0">Select Type</option>
							{propertyTypeData.map((type) => (
								<option value={type.id}>{type.name}</option>
							))}
						</Form.Select>
					</Form.Group>
				</Col>
			</Row>
			<Row>
				<Col md={8} className="mb-3">
					<Form.Group id="propertyAddress">
						<Form.Label>Address</Form.Label>
						<Form.Control
							required
							type="text"
							name="address"
							value={localPropertyData?.["address"] ?? ""}
							onChange={(e) => handleInputChange(e)}
							placeholder="Enter property address (Hourse, Road, Block, Holding etc.)"
						/>
					</Form.Group>
				</Col>

				<Col md={4} className="mb-3">
					<Form.Group id="propertyArea">
						<Form.Label>Area</Form.Label>
						<Form.Control
							required
							type="text"
							name="area"
							value={localPropertyData?.["area"] ?? ""}
							onChange={(e) => handleInputChange(e)}
							placeholder="e.g: Sugondha Beach"
						/>
					</Form.Group>
				</Col>
			</Row>
			<Row>
				<Col md={6} className="mb-3">
					<Form.Group id="propertyDistrict">
						<Form.Label>City</Form.Label>
						<Form.Select
							required
							id="state"
							name="district"
							data-key="district_id"
							defaultValue="0"
							value={localPropertyData?.["district_id"] ?? 0}
							onChange={(e) => handleInputChange(e)}
						>
							<option value="0">Select District</option>
							{districtsData.map((district) => (
								<option value={district.id}>{district.name}</option>
							))}
						</Form.Select>
					</Form.Group>
				</Col>
				<Col md={6} className="mb-3">
					<Form.Group id="propertyPostalCode">
						<Form.Label>Postal Code</Form.Label>
						<Form.Control
							required
							type="text"
							name="post_code"
							value={localPropertyData?.["post_code"] ?? ""}
							onChange={(e) => handleInputChange(e)}
							placeholder="Enter postal code"
						/>
					</Form.Group>
				</Col>
			</Row>
			<Row>
			<Col md={12} className="mb-3">
					<Form.Group id="propertyDescription">
						<Form.Label>Description</Form.Label>
						<ReactQuill 
							value={localPropertyData?.["description"] ?? ""}
							name="description"
							placeholder="Property description"
							onChange={(text, a, b, c, d, e) => handleDescriptionChange(text, a, b, c, d, e)}
						/>
					</Form.Group>
				</Col>
			</Row>
			<Row>
				<Col md={4} className="mb-3">
					<Form.Group id="propertyLowPrice">
						<Form.Label>Price Low</Form.Label>
						<Form.Control
							type="number"
							min="300"
							value={localPropertyData?.price_low ?? localPropertyData?.price}
							onChange={handleLowPrice}
						/>
					</Form.Group>
				</Col>
				<Col md={4} className="mb-3">
					<Form.Group id="propertyHighPrice">
						<Form.Label>Price High</Form.Label>
						<Form.Control
							type="number"
							min="300"
							value={localPropertyData?.price_high ?? localPropertyData?.price}
							onChange={handleHighPrice}
						/>
					</Form.Group>
				</Col>
				<Col md={4} className="mb-3">
					<Form.Group id="propertyPriceType">
						<Form.Label>Price Type</Form.Label>
						<Form.Select
							value={localPropertyData?.price_type || "night"}
							onChange={(e) =>
								setlocalPropertyData({
									...localPropertyData,
									price_type: e.target.value,
								})
							}
						>
							<option value="">Select price type</option>
							<option value="night">Per Night</option>
							<option value="month">Per Month</option>
							<option value="sale">Sale</option>
						</Form.Select>
					</Form.Group>
				</Col>
			</Row>
		</div>
	);
};

export default BasicDataInput;
